<template>
  <div class="add-user">
    <el-form-item label="账号：" class="select-width">
      <el-input v-model="addParam.mobile" placeholder="请输入账号" clearable style="height: 40px;"></el-input>
    </el-form-item>
    <el-form-item label="密码：" class="select-width-2" style="height: 40px;">
      <el-input v-model="addParam.password" placeholder="请输入密码" clearable style="height: 40px;"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button @click="handleAdd" class="button">提交</el-button>
    </el-form-item>
  </div>

</template>

<script setup>
import { reactive, getCurrentInstance } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
// 路由实例
const router = useRouter()
const { proxy } = getCurrentInstance();
const addParam = reactive({
  mobile: '',
  password: ''
})

const handleAdd = () => {
  const url = '/login/addUser';
  proxy.$tools.request(url,
    {
      reqBody: { mobileNo: addParam.mobile, password: addParam.password },
    })
    .then(response => {
      // 处理响应数据
      if ('00000000' === response.data.rspHead.returnCode) {
        // router.push('/');
        // 返回上级页面，可以使用router的go方法
        ElMessage.success('新增成功');
        router.push('/houseCart/userManage')
      } else {
        ElMessage.error(response.data.rspHead.returnMsg); // 弹框提示错误信息
      }
    })
    .catch(error => {
      // 处理错误情况
      ElMessage.error('系统异常，请联系管理员' + error);
    });
}
</script>

<style scoped>
.add-user {
  max-width: 400px;
  margin: 50px auto;
  padding: 20px;
  border-radius: 8px;
}

.select-width {
  width: 300px;
}

.select-width-2 {
  margin-top: 30px;
  width: 300px;
  margin-bottom: 40px;
}

.button {
  background-color: #2b82cf;
  width: 100px;
  height: 35px;
  border: 1px solid #2b82cf;
  border-radius: 4px;
  font-size: 14px;
  color: #fff;
  margin-left: 100px;
}

.button:hover {
  background-color: #409eff;
  color: #fff;
}

/* 调整表单项标签的对齐方式 */
.add-user :deep(.el-form-item__label) {
  height: 40px;
  line-height: 40px;
  font-size: 14px;
}
</style>